<div class="offering-support-channels">
  <h1 class="ui-heading-3 offering-support-hours-title">{{ section() }}</h1>

  <dl class="support-hours">
    @for (supportHour of supportHours(); track $index) {
      <div class="support-hours-row">
        <dt class="ui-body-m">{{ formatDays(supportHour.days) }}</dt>
        <dd class="ui-body-m time-details">
          {{ supportHour.startTime | date: "shortTime" }} -
          {{ supportHour.endTime | date: "shortTime" }} ({{
            supportHour.timezone
          }})
          <p class="ui-label-m-bold"> {{ OFFERING_TEXT.OFFERINGS.SUPPORTED_HOURS_SECTION.RESPONSE_TIME }}</p>
          <rds-badge
            size="m"
            [label]="supportHour.responseTime"
            type="minimal"
          ></rds-badge>
        </dd>
      </div>
    }
  </dl>
</div>
